import { Component, type ErrorInfo, type ReactNode } from 'react';
import { irA } from '../../router';
import { Boton } from '../Boton';
import { Icono } from '../Icono';

interface Props {
  /** Al cambiar de ruta se vuelve a intentar: el error era de la pantalla anterior. */
  ruta: string;
  children: ReactNode;
}

interface Estado {
  error: Error | null;
  rutaDelError: string | null;
}

// Si una pantalla falla, se muestra este cartel con la opción de volver en vez de
// dejar la página en blanco. El resto de la aplicación sigue funcionando.
export class LimiteDeError extends Component<Props, Estado> {
  override state: Estado = { error: null, rutaDelError: null };

  static getDerivedStateFromError(error: Error): Partial<Estado> {
    return { error };
  }

  static getDerivedStateFromProps(props: Props, estado: Estado): Partial<Estado> | null {
    if (!estado.error) return { rutaDelError: props.ruta };
    if (estado.rutaDelError !== props.ruta) return { error: null, rutaDelError: props.ruta };
    return null;
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Falla en una pantalla:', error, info.componentStack);
  }

  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="falla">
        <div className="falla__tarjeta" role="alert">
          <div className="falla__icono">
            <Icono nombre="alert-triangle" tamano={26} />
          </div>
          <h2 className="falla__titulo">Algo no salió como esperábamos</h2>
          <p className="falla__texto">
            La pantalla no se pudo mostrar. El resto del sistema sigue funcionando: podés volver e intentar de nuevo.
          </p>
          <Boton onClick={() => { this.setState({ error: null }); irA('/inicio'); }}>
            Volver al inicio
          </Boton>
        </div>
      </div>
    );
  }
}
